



















































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import { Toast,Dialog } from "vant";
import { TbOrderPad, TbReturnOrder, TbSettingsPad, TbShop, TbShopAccount } from "@/http";
import calculate from "@/common/util/calculate";
import { fmoney } from "@/common/util/money";
import {PrintEvent1,PrintEvent3} from "@/common/util/prints";
import JsBarcode from 'jsbarcode';
import { TbShopReceiptTemplate } from "@/http/api_TbShopReceiptTemplate";
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({
  components: {},
})
export default class details extends Vue {
  public $refs: {};

  show = false;

  form: any = {};
  type = 1;

  fmoney = fmoney;

  loading = false;
  changesyy = false;
  cashierlist = [];
  curselid = "";
  curselname = "";

  userInfo = {};

  isPrintLoading = false;

  created() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
  }
  mounted() {
  }


  async init(id, tag) {
    this.loading = true;
    try {
      if (tag == 1) {
        let res = await TbOrderPad.GetOrderById({
          id: id,
        });
        this.form = res;
      }
      if (tag == 2) {
        let res = await TbReturnOrder.GetReturnOrderInfoById({
          id: id,
        });
        this.form = res;
      }
      if (tag == 3) {
        let res = await TbOrderPad.GetAbnormalOrderById({
          id: id,
        });
        this.form = res;
      }
      if (tag == 4) {
        let res = await TbReturnOrder.GetAbnormalReturnOrderInfoById({
          id: id,
        });
        this.form = res;
      }

      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }
  getpriceall() {
    return this.form.items
      .map((v) => v.price)
      .reduce((pre, cur) => {
        return Number(pre) + Number(cur);
      }, 0);
  }

  async showFun(id, tag) {
    this.type = tag;
    await this.init(id, tag);
    this.show = true;
  }

  closeFun() {
    this.resetFun();
    this.show = false;
  }

  resetFun() {
    this.form = {};
  }
  openchange() {
    this.getcashierlist();
    this.curselid = this.form.cashierId;
    this.changesyy = true;
  }
  async getcashierlist() {
    try {
      let res = await TbShopAccount.GetTbShopAccountDropList({
        shopid: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
      });
      this.cashierlist = res;
    } catch (error) {}
  }
  selcashier(item) {
    this.curselid = item.id;
    this.curselname = item.name;
  }
  async confirm_syy() {
    if (this.curselid == this.form.cashierId) {
      return;
    }
    try {
      let res = await TbOrderPad.PutChangeCashier({
        orderId: this.form.id,
        cashierId: this.curselid,
        cashier: this.curselname,
      });
      Toast("修改成功");
      this.init(this.form.id, this.type);
      this.changesyy = false;
    } catch (error) {}
  }
  closeFun_syy() {
    this.curselid = "";
    this.curselname = "";
    this.changesyy = false;
  }
  getxjsum() {
    if (this.form.items && this.form.items.length > 0) {
      let arr = this.form.items.map((v) => {
        return Number(v.sellingPrice) * Number(v.num);
      });
      return fmoney(
        arr.reduce((pre, cur) => {
          return Number(pre) + Number(cur);
        }, 0),
        2,
        true
      );
    } else {
      return "-￥0.00";
    }
  }
  /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }

    async printTest(){
        if(this.isPrintLoading) return;
        this.isPrintLoading = true;
        let address = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')).address:''

        let shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
        let resShop = await TbShop.GetInitShopInfo({shopid:shopInfo.id});
        let isnewReceipt = resShop.webShopReceiptTemplateType;
        if(isnewReceipt==0){
          let resSetting= await TbSettingsPad.GetTbSettings({
          settingtype: 5,
          });
          let form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfo:Object.assign({},this.form,{address:address})},{type:'receipt'})
          let time = 3000*resSetting.settingContent.putNum
          if(form.settingContent.putNum>0){
              for(let i =1;i<=form.settingContent.putNum;i++){
                  setTimeout(()=>{
                    const canvas = this.$refs['barcodeCanvas'];
                    JsBarcode('canvas', form.orderInfo.orderNo, {
                      format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                      lineColor: "#000",
                      width: 3,
                      height: 100,
                      displayValue: false
                    });
                    let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
                      PrintEvent1(form,barcodeImage)
                  },3000)
              }
          }
          setTimeout(()=>{
            this.isPrintLoading = false;
          },time)
        }else{
          let res = await TbShopReceiptTemplate.GetTbShopReceiptTemplate({
                    shopNo:shopInfo.shopNo,
                    shopId:shopInfo.id
                })
                let padSetInfo= res;
                let form = Object.assign({},{settingContent:padSetInfo},{orderInfo:Object.assign({},this.form,{address:address})},{type:'receipt'});
                let putNum = res.contentJson.receiptTemplateMore.printNum?res.contentJson.receiptTemplateMore.printNum:1;
                let time = 3000*putNum;
                setTimeout(()=>{
                    const canvas = this.$refs['barcodeCanvas'];
                    JsBarcode('canvas', form.orderInfo.orderNo, {
                        format: "CODE128", // 可以选择不同的格式，例如 CODE128, CODE39 等
                        lineColor: "#000",
                        width: 3,
                        height: 100,
                        displayValue: false
                    });
                    let barcodeImage = canvas.toDataURL("image/png"); // 转换为Base64编码的PNG图像
                    PrintEvent3(form,barcodeImage,putNum)
                },3000)

                setTimeout(()=>{
                    this.isPrintLoading = false;
                },time)
        }
    }
    //查询支付结果
    async searchPay(){
      try {
        Toast.loading({
            message: "加载中",
            duration: 0, // toast不消失
        });
        let res = await TbOrderPad.GetOrderStatusV2({orderId:this.form.id});
        console.log('res',res);
        Dialog.confirm({
            title: "支付结果",
            message: res.error_Message,
            showCancelButton:false,
        })
            .then(async () => {
              this.init(this.form.id, this.type);
            })
            .catch(() => {
            });

        Toast.clear();
      }catch {
        Toast.clear();
      }
    }
    //退货查询
    async thsearchPay(thtype){
      try {
        Toast.loading({
            message: "加载中",
            duration: 0, // toast不消失
        });
        if(thtype==1) {
          let res = await TbReturnOrder.GetReturnOrderStatus({returnOrderId:this.form.id});
          console.log('res',res);
          Dialog.confirm({
              title: res.refundInfo.status!=3?"退款结果":"订单已关闭",
              message: res.success?res.refundInfo.status==1?"成功":res.refundInfo.status==2?"处理中":res.refundInfo.error:res.error,
              showCancelButton:false,
              confirmButtonText:'我知道了'
          })
              .then(async () => {
                // this.init(this.form.id, this.type);
                this.closeFun();
                this.$emit('dialoggetList');
              })
              .catch(() => {
              });
        }else{
          let res = await TbReturnOrder.CloseOnlineReturnOrder({returnOrderId:this.form.id});
          this.init(this.form.id, this.type);
        }
        Toast.clear();
      }catch {
        Toast.clear();
      }
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/detail.vue